import { API, get } from "../../config";

export const getSubAssetDetail = async (subAssetId) => {
  try {
    const { data } = await get(`${API.SUB_ASSETS_DETAILS}/` + subAssetId);
    return data.data;
  } catch (e) {
    return null;
  }
};
